module.exports = __webpack_public_path__ + "img/Indicator.cce97645.svg";